<svg width="100%" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3.43994" y="2" width="6.8376" height="20" fill="currentColor"/>
<rect x="14.7227" y="2" width="6.8376" height="20" fill="currentColor"/>
</svg>
